// ================= MECHANICS TELEMETRY =================
//
// DID ANY OF IT WORK. The mechanics-visibility brief asks for instrumentation for one stated reason:
// "so the redesign can be evaluated with human players, not only simulation outcomes." A simulated
// bout cannot open a definition, cannot re-read a badge, and cannot be confused -- so nothing in
// tools/ or tests/ can answer whether a player learned what Absorb does.
//
// LOCAL ONLY, AND THAT IS A DELIBERATE CEILING. Every counter here lives in this browser and travels
// only if the player downloads a bout log. Sending it anywhere is a different decision with a
// different cost: a new endpoint under functions/, a D1 migration, and the repo's own rule that
// migrations ship before code (see the constraints in CLAUDE.md). None of that is worth doing before
// anyone has looked at whether the local numbers say anything, so this is the cheap half and the
// server half is deliberately not built.
//
// COUNTS, NEVER CONTENT. Each key is a mechanic name and an event name -- "sheetOpened.Absorb" -- so
// the file can say "definitions were opened 14 times, 9 of them for Deny" and can say nothing about
// who was playing or what deck they used. There is no id here and nothing to correlate with.
(function () {
  'use strict';

  const KEY = 'sc.mechTelemetry.v1';

  // Guarded exactly as js/credits.js guards its queue: localStorage throws rather than returning
  // null in a private window, and telemetry is the last thing that should be able to break a bout.
  function store() {
    try { return window.localStorage; } catch (e) { return null; }
  }

  function read() {
    const s = store();
    if (!s) return {};
    try { return JSON.parse(s.getItem(KEY) || '{}') || {}; } catch (e) { return {}; }
  }

  function save(data) {
    const s = store();
    if (!s) return false;
    try { s.setItem(KEY, JSON.stringify(data)); return true; } catch (e) { return false; }
  }

  // The whole write path. `what` is the interaction, `mechanic` is optional -- some events (a badge
  // opened from the glossary index) have no single mechanic behind them.
  function note(what, mechanic) {
    if (!what) return false;
    const data = read();
    const key = mechanic ? what + '.' + mechanic : what;
    data[key] = (data[key] || 0) + 1;
    data._total = (data._total || 0) + 1;
    return save(data);
  }

  // For the downloadable bout log and for a developer readout. Returns a copy, so a caller cannot
  // mutate the stored object by holding it.
  function snapshot() { return Object.assign({}, read()); }

  function clear() {
    const s = store();
    try { if (s) s.removeItem(KEY); } catch (e) { /* nothing to clear */ }
  }

  // A one-line human summary, for the console and for the log's metadata. Deliberately not a UI:
  // the brief asks for instrumentation to evaluate the redesign, not for a dashboard inside a game.
  function summary() {
    const data = read();
    const keys = Object.keys(data).filter(k => k.charAt(0) !== '_').sort((a, b) => data[b] - data[a]);
    if (!keys.length) return 'no mechanics interactions recorded';
    return keys.map(k => k + ': ' + data[k]).join(', ');
  }

  window.MechanicsTelemetry = { note, snapshot, clear, summary, KEY };
})();
